// noinspection JSValidateTypes

import {assign, isEqual, isNil, isString, merge, omitBy, trim,} from "lodash";

export default {
    methods: {
        getRouteData() {
            return this.$route;
        },
        getData(query) {

            const route = this.getRouteData();

            const newRoute = assign({}, this.$route, {
                query: omitBy(query, value => isNil(value) || (isString(value) && trim(value) === ''))
            });


            if (!isEqual(route.query, newRoute.query)) {
                this.$router.push(newRoute);
            }
        },
        onSort(data) {
            let sort = data.field ? data.field : this.parseSort(this.constraints.sort).field;
            sort = (data.ascending ? '' : '-') + sort;

            this.getData(merge(this.constraints, {sort, page: null}));
        },
        onPageChange(page) {
            this.getData(merge(this.constraints, {page}));
        },
        parseSort(sort) {

            if (sort.startsWith('-')) {
                return {
                    field: sort.substr(1),
                    ascending: false
                }
            }

            return {
                field: sort,
                ascending: true
            }
        }
    },

    computed: {
        initialSort() {
            if (this.constraints.sort) {
                return this.parseSort(this.constraints.sort);
            }
        }
    },
};
